export const TimelineConstants = {
  rowHeight: 32,
  rowSpacing: 24,
  xPadding: 24,
  yPadding: 24,
  flagOffsetOffsetFromLine: 2,
  flagTextPaddingX: 4,
  flagMinSpacing: 8,
  flagHeight: 20,
  badgeAreaWidth: 130,
  barStrokeWidth: 4,
  barTextMinWidth: 60,
};
